import { createActions, createReducer } from "reduxsauce"
import { Types as CreatorTypes } from "model/creator"
import { Types as UpdaterTypes } from "model/updater"
import { Types as DeleterTypes } from "model/deleter"
import { Types as BaseTypes } from "modules/portfolio-root/model"

export const { Types, Creators } = createActions({
  setCurrentFilter: ["id", "name", "filter"],
}, {
  prefix: "ompnt/modules/filter-saver/",
})

const DEFAULT_STATE = {
  currentFilterId: null,
  currentFilterName: null,
  currentFilter: null,
}

function handleSetCurrentFilter(state, { id, name, filter }) {
  return {
    currentFilterId: id,
    currentFilterName: name,
    currentFilter: filter,
  }
}

function handleSuccess(state, { result: { id, name, filter } }) {
  return {
    currentFilterId: id,
    currentFilterName: name,
    currentFilter: filter,
  }
}

function handleDeleteSuccess(state, { deletedId }) {
  if (state.currentFilterId === deletedId) {
    return {
      currentFilterId: null,
      currentFilterName: null,
      currentFilter: state.currentFilter,
    }
  } else {
    return state
  }
}

function handleModelChange(state) {
  return { ...state, ...DEFAULT_STATE }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_CURRENT_FILTER]: handleSetCurrentFilter,
  [UpdaterTypes.UPDATE_SUCCESS]: handleSuccess,
  [CreatorTypes.CREATE_SUCCESS]: handleSuccess,
  [DeleterTypes.DELETE_SUCCESS]: handleDeleteSuccess,
  [BaseTypes.SET_MODEL]: handleModelChange,
})
